/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListadoProgramaArticulosModel } from '../../models/listado-programa-articulos-model';

export interface ArticulosControllerObtenerArticulosPorPrograma$Params {
}

export function articulosControllerObtenerArticulosPorPrograma(http: HttpClient, rootUrl: string, params?: ArticulosControllerObtenerArticulosPorPrograma$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ListadoProgramaArticulosModel>>> {
  const rb = new RequestBuilder(rootUrl, articulosControllerObtenerArticulosPorPrograma.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ListadoProgramaArticulosModel>>;
    })
  );
}

articulosControllerObtenerArticulosPorPrograma.PATH = '/api/articulos/obtener-articulos';
